import { Box, Divider, Grid, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import "./style.css";
import CustomButton from 'components/Fileds/CustomButton';
import AddIcon from "@mui/icons-material/Add";
import CustomTypography from 'components/Fileds/CustomTypography';
import RestaurantInfo from 'components/RestaurantInfo/RestaurantInfo';
import SummaryCard from 'components/SummaryCard/SummaryCard';
import OrderSummary from 'components/OrderSummary/OrderSummary';


const TimeDisplay = React.memo(function TimeDisplay() {
    const [now, setNow] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setNow(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    const dateStr = now.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
    const timeStr = now.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });

    return (
        <Box className="d-flex align-items-center" sx={{ flexDirection: 'column' }}>
            <CustomTypography variant="h5" label="TODAY" sx={{ fontSize: 20, fontWeight: 700, mb: 0 }} />
            <CustomTypography variant="body2" label={`${dateStr} | ${timeStr}`} />
        </Box>
    );
});

const TablesInfoHeader = ({ handleOpenDialog, loginData, summaryData, isLoading }) => {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down("sm"))

    return (
        <Box
            sx={{
                pt: 3,
                // pb: 1,
                px: '50px',
            }}
        >
            <Box className='tables-info-container'>
                <Box
                    className="order-summary-container"
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "20px",
                        width: "100%",
                        alignItems: "center",
                    }}
                >
                    {summaryData?.map((item) => (
                        <Box
                            key={item.id}
                            sx={{
                                flex: {
                                    xs: "0 calc(50% - 10px)", // 2 per row
                                    md: "0 calc(25% - 80px)", // 4 per row
                                },
                            }}
                        >
                            <SummaryCard
                                item={item}
                                isSmall={isSmall}
                                theme={theme}
                                isLoading={isLoading}
                            />
                        </Box>
                    ))}
                </Box>
                {/* </Box> */}
                <Box className='d-flex align-items-center justify-content-between'>
                    <CustomButton
                        variant="contained"
                        startIcon={<AddIcon />}
                        fullWidth
                        sx={{
                            borderRadius: "10px",
                            width: "150px",
                            textTransform: "none",
                        }}
                        onClick={handleOpenDialog}
                    >
                        Add Table
                    </CustomButton>
                </Box>
            </Box>
            <Divider sx={{ my: 2 }} />

        </Box >
    )
}

export default TablesInfoHeader
